import Head from "next/head";

import { useTranslator } from "@eo-locale/react";

import { Text, Heading } from "@/storybook-components";
import Form from "./form";
import { useAppSelector } from "@/redux/store/hooks";

const App = (): JSX.Element => {
  const { translate } = useTranslator();
  const { name } = useAppSelector((state) => state.site.site);

  return (
    <>
      <Head>
        <title>{`${translate("users.forgotPassword")} | ${name}`}</title>
      </Head>
      <Heading as="h1" my={3}>
        {translate("users.changePassword")}
      </Heading>
      <Text my={3}>{translate("users.editPasswordDescription")}</Text>
      <Form />
    </>
  );
};

export default App;
